<div class="m-pagination"
     :class="{'m--is-loading': loading}">
    <div class="m-pagination__status"
         ref="status">{{ status }}</div>
    <div v-if="pagesTotal > 1"
         class="m-pagination__indicator"></div>
    <div v-if="pagesTotal > 1"
         class="m-pagination__nav"
         ref="navigation">
        <m-icon-button class="m-pagination__previous-button"
                       ref="previous"
                       @click="goToPage(value - 1)"
                       :disabled="firstPageSelected || loading"
                       icon-name="m-svg__chevron-circle--left"
                       :title="'m-pagination:previous' | f-m-i18n"
                       skin="link">
            <m-i18n k="m-pagination:previous"></m-i18n>
        </m-icon-button>
        <ul class="m-pagination__pages">
            <li v-for="(item, index) of paginationItems"
                class="m-pagination__item"
                :class="{'m-pagination__item--ellipsis': item.ellipsis, 'm--is-active': isPageActive(parseInt(item.label))}"
                :key="index">
                <m-link v-if="item.clickable"
                        class="m-pagination__item--link"
                        @click="goToPage(parseInt(item.label))"
                        :disabled="loading"
                        mode="button">{{ item.label }}</m-link>
                <span v-else
                      class="m-pagination__item--text">{{ item.label }}</span>
            </li>
        </ul>
        <m-icon-button class="m-pagination__next-button"
                       ref="next"
                       @click="goToPage(value + 1)"
                       :disabled="lastPageSelected || loading"
                       icon-name="m-svg__chevron-circle--right"
                       :title="'m-pagination:next' | f-m-i18n"
                       skin="link">
            <m-i18n k="m-pagination:next"></m-i18n>
        </m-icon-button>
    </div>
</div>
